export interface EanRegexModel {
  digitsRegex: string;
  lengthRegex: string;
}

export const eanRegex: EanRegexModel = {
  digitsRegex: '^(\\d+)$',
  lengthRegex: '^(\\d{8}|\\d{12,14})$',
};
